



















































import Vue from 'vue';

export default Vue.extend({
  name: 'G_KAIGAI_ActionsBtn',
  props: {
    info: {
      type: [Boolean, Number],
      default: true,
    },
    edit: {
      type: [Boolean, Number],
      default: true,
    },
    copy: {
      type: [Boolean, Number],
      default: true,
    },
    remove: {
      type: [Boolean, Number],
      default: true,
    },
  },
});
